"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Greeting = void 0;
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var React = require("react");
var react_redux_1 = require("react-redux");
require("./style.scss");
var GreetingComponent = function (_a) {
    var username = _a.username, message = _a.message;
    return (React.createElement("div", { className: "sok-greeting" },
        React.createElement("p", { className: "sok-greeting-hi-user" },
            (0, translation_1.getLocalization)('components/greeting/hi'),
            ' ',
            React.createElement("strong", { className: "sok-greeting-username" }, username || 'user'),
            "!"),
        message && React.createElement("p", { className: "sok-greeting-message" }, message)));
};
var mapStateToProps = function (state) { return ({
    username: state.auth &&
        state.auth.current.user
            .map(function (info) { return (info.status === 'VALID' ? info.firstName : ''); })
            .getOrElse('')
}); };
exports.Greeting = (0, react_redux_1.connect)(mapStateToProps)(GreetingComponent);
exports.default = exports.Greeting;
